import { render, staticRenderFns } from "./LicitacoesDisponiveisTabela.vue?vue&type=template&id=71abf891&scoped=true&"
import script from "./LicitacoesDisponiveisTabela.vue?vue&type=script&lang=js&"
export * from "./LicitacoesDisponiveisTabela.vue?vue&type=script&lang=js&"
import style0 from "./LicitacoesDisponiveisTabela.vue?vue&type=style&index=0&id=71abf891&prod&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71abf891",
  null
  
)

export default component.exports